import { useEffect, useState } from 'react';
import { api } from '../utils';

export default function useGetPOReviewDetails(itemObj) {
  const { datum } = itemObj;
  const [reviewList, setReviewList] = useState({ working: true, list: [] });

  useEffect(() => {
    if (!datum || datum?.reviewId === 0) {
      if (datum && datum.reviewId === 0) {
        setReviewList({
          working: false,
          list: []
        })
      }
      return;
    }
    api.fetch(`Inventory/GetPOReviewDetailList/${datum.reviewId}`)
      .then(response => {
        if (response.data.success) {
          return response.data
        } else {
          throw new Error("Whoops fetching reviewList info returned false!");
        }
      }).then(data => setReviewList({
        working: false,
        list: data.reviewList
      }))
      .catch(api.catchHandler);
  }, [datum]);

  return reviewList;
}